import { render, staticRenderFns } from "./auction-halls-search.vue?vue&type=template&id=137767a3&"
import script from "./auction-halls-search.vue?vue&type=script&lang=js&"
export * from "./auction-halls-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports